import type { Edge, Node } from '@xyflow/react'
import { getNodeDefinition } from '../nodes/registry'
import { isWorkflowNodeType, WorkflowNodeType } from '../nodes/types'

export interface UpstreamTextSource {
  type: WorkflowNodeType
  labelKey: string
}

/** Luca writes text only for its immediate successor. */
export const resolveUpstreamTextSource = (
  nodeId: string,
  nodes: Node[],
  edges: Edge[]
): UpstreamTextSource | null => {
  const incoming = edges.filter(edge => edge.target === nodeId)
  if (incoming.length !== 1) return null

  const source = nodes.find(node => node.id === incoming[0].source)
  if (!source || !isWorkflowNodeType(source.type)) return null

  const definition = getNodeDefinition(source.type)
  if (!definition.providesTextOutput) return null

  return { type: source.type, labelKey: definition.labelKey }
}
